<template>
    <div>
        <div id="figures" v-if="location == 1">
            <img src="/assets/img/figures-g-green-hor.svg" class="figure girl-green" />
            <img src="/assets/img/figures-g-yellow-hor.svg" class="figure girl-yellow" />
            <img src="/assets/img/figures-g-b-hor.svg" class="figure girl-boy" />
            <img src="/assets/img/figures-b-g-hor.svg" class="figure boy-girl" />
        </div>

        <div id="figures" v-if="location == 2">
            <img src="/assets/img/figures-g-green-kus.svg" class="figure girl-green" />
            <img src="/assets/img/figures-g-yellow-kus.svg" class="figure girl-yellow" />
            <img src="/assets/img/figures-g-b-kus.svg" class="figure girl-boy" />
            <img src="/assets/img/figures-b-g-kus.svg" class="figure boy-girl" />
        </div>


        <section class="offer page-wrapper-inner" v-if="dataIsInit">
            <div class="block">

                <div>
                    <label class="subtitle horgen" v-if="location == 1">Horgen</label>
                    <label class="subtitle kuesnacht"  v-if="location == 2">Küsnacht</label>
                    <h2>{{ trans.schoolbus.title[lang] }}</h2>


                    <!-- <ul class="link-block">
                        <li><a href="#" class="more">{{ trans.global.organisation[lang] }} +</a></li>
                        <li><a href="#" class="more">{{ trans.global.terms[lang] }} +</a></li>
                    </ul> -->
                </div>

                <div>
                   <h3>{{ trans.schoolbus.station_title[lang] }}</h3>
                   <p>{{ trans.schoolbus.station_text[lang] }}</p>

                   <ul class="block-list">
                       <li>
                           <h5 style="margin:0 0 1em 0">{{ trans.schoolbus.choosestation[lang] }}:</h5>
                           <div class="price_row">
                               <div>
                                   <label v-on:click="stationbusInput('Tiefenbrunnen')">
                                       <span v-bind:class="[stationbus == 'Tiefenbrunnen' ? 'checkbox checked' : 'checkbox', ]"></span>
                                       Tiefenbrunnen
                                   </label>
                                   <label v-on:click="stationbusInput('Küsnacht')">
                                        <span v-bind:class="[stationbus == 'Küsnacht' ? 'checkbox checked' : 'checkbox', ]"></span>
                                        Küsnacht
                                    </label>
                                   </div>
                                <span>
                                   {{ trans.global.chf_month[lang] }}
                                 </span>
                                <em><i>0.—</i></em>
                           </div>
                            <div v-if="stationbus" class="subcheckboxes">
                                <label v-on:click="time_stationbus = 'mornings_afternoons';setBusservices()">
                                    <span v-bind:class="[time_stationbus == 'mornings_afternoons' ? 'checkbox checked' : 'checkbox', ]"></span>
                                    {{ trans.schoolbus.mornings_afternoons[lang] }}
                                </label>

                                <label v-on:click="time_stationbus = 'mornings';setBusservices()">
                                    <span v-bind:class="[time_stationbus == 'mornings' ? 'checkbox checked' : 'checkbox', ]"></span>
                                    {{ trans.schoolbus.mornings[lang] }}
                                </label>

                                <label v-on:click="time_stationbus = 'afternoons';setBusservices()">
                                    <span v-bind:class="[time_stationbus == 'afternoons' ? 'checkbox checked' : 'checkbox', ]"></span>
                                    {{ trans.schoolbus.afternoons[lang] }}
                                </label>

                            </div>

                       </li>
                   </ul>



                   <h3>{{ trans.schoolbus.bustour_title[lang] }}</h3>
                   <div v-if="lang == 'en'">
                       <p>
                       The school bus tours are planned once a year at the beginning of June. Changes to the bus tours within the school year are only possible to a very limited extent. The bus tours usually start earliest at 8:00. Pick-up places are within a short walking distance from home. Pick-up by a bus tour is not guaranteed and there may be major changes every year at the start of the new school year. The definitive timetable will be available by the end of June.
                       </p>
                       <p>
                       <strong>The school bus must be booked for every school day, except for children who are in Day Care or Pre-Kindergarten on certain days.</strong> The school bus must be used for a minimum of 5 trips per week for a bus stop to be included in the planning of the bus schedule.
                       </p>
                       <p>
                       For detailed information on bus tours and stops as well as the bus costs, please contact us directly: <a href="mailto:kuesnacht@lakesideschool.ch">kuesnacht@lakesideschool.ch</a> or 044/914&nbsp;20&nbsp;50
                       </p>
                       <p>
                       Payment in advance at the beginning of each month. No refund in case of illness or absence. The school bus can be cancelled at any time in writing at the end of a month, with a notice period of two months.
                       </p>
                   </div>
                   <div v-if="lang == 'de'">
                       <p>
                         Die Schulbustouren werden einmal im Jahr anfangs Juni neu zusammengestellt. Änderungen der Bustouren innerhalb des Schuljahres sind nur beschränkt möglich. Die Bustouren starten in der Regel frühestens um 8.00 Uhr. Abholpunkte sind in kurzer Gehdistanz von zu Hause erreichbar. Die Abholung wird nicht garantiert und es kann alljährlich auf jeden Schuljahreswechsel hin auch grössere Änderungen geben. Der definitive Fahrplan steht jeweils ca. Ende Juni zur Verfügung.
                       </p><p>
                         <strong>Der Schulbus kann nur für alle Tage gebucht werden, ausgenommen für Kinder, die nur tageweise in Day Care oder Pre-Kindergarten sind.</strong> Der Schulbus muss für minimal 5 Fahrten pro Woche benutzt werden, damit eine Haltestelle in die Busfahrplanung mit einbezogen wird.
                        </p><p>
                         Für detaillierte Informationen zu den Bustouren und Haltestellen sowie den effektiven Buskosten kontaktieren Sie uns bitte direkt: <a href="mailto:kuesnacht@lakesideschool.ch">kuesnacht@lakesideschool.ch</a> oder 044/914&nbsp;20&nbsp;50
                        </p><p>
                         Vorauszahlung der monatlichen Pauschale anfangs jeden Monats. Keine Erstattung bei Krankheit oder Abwesenheit. Der Schulbus ist mit einer Kündigungsfrist von 2 Monaten jederzeit auf Ende eines Monats schriftlich kündbar.
                        </p>
                      </div>

                   <br><br>

                   <ul class="block-list">
                          <li>
                              <div class="price_row">
                                  <div>
                                      <label v-on:click="schoolbusInput">
                                          <span v-bind:class="[schoolbus ? 'checkbox checked' : 'checkbox', ]"></span>
                                          <div style="display:inline-block">{{ trans.schoolbus.schoolbusroute[lang] }}
                                          </div>
                                      </label>
                                    </div>
                                   <span>
                                      {{ trans.global.chf_month[lang] }}  <br>{{ trans.global.excl_mwst[lang] }}
                                    </span>
                                   <em><i v-if="schoolbus">300.—</i><i v-else>0.—</i></em>
                              </div>
                              <div class="price_row">
                                    <div class="remarks">
                                        {{ trans.schoolbus.schoolbusroute_remarks[lang] }}
                                      </div>
                                </div>
                          </li>
                      </ul>
                </div>


              <div class="applicationbox" v-if="schoolbus || stationbus" >
                  <p>{{ trans.global.c2a_finish[lang] }}</p>
                  <button class="btnoutline" v-on:click="prepairData(modulRelevantSelections,6,'pdf')">{{ trans.global.downloadpdf[lang] }}</button>
                  <button class="btn" v-if="appmode=='offer'"  v-on:click="prepairData(modulRelevantSelections,6,'app')">{{ trans.global.register[lang] }}</button>
                  <button class="btn" v-if="appmode=='change'" v-on:click="prepairData(modulRelevantSelections,6,'app')">{{ trans.global.confirm[lang] }}</button>
              </div>
              <div v-else>
                  <br><br>
              </div>


            </div>
        </section>

         <div class="teaser-wrapper">
            <h3 class="title"></h3>
            <div class="grid">
                 <div class="teaser">
                    <p>{{ trans.teaser.about_pri.text[lang] }}</p>
                    <a :href="trans.teaser.about_pri.link[location][lang]" target="_blank">{{ trans.teaser.about_pri.linktext[lang] }}</a>
                </div>
                <div class="teaser" v-if="location != 2">
                    <p>{{ trans.teaser.video_pri.text[lang] }}</p>
                    <a :href="trans.teaser.video_pri.link[location][lang]" target="_blank">{{ trans.teaser.video_pri.linktext[lang] }}</a>
                </div>
            </div>
        </div>

    </div>
</template>




<script>

    import * as helpers from "./helpers.js";
    import * as methods from "./methods.js";

    export default {


        data: function() {
            return  {


                config:{
                    sectorIds: [ 6 ], //  Sonstiges
                    serviceIdSchoolbus: 30,
                    serviceIdstationbusTiefenbrunnen_all: 21,
                    serviceIdstationbusTiefenbrunnen_mornings: 22,
                    serviceIdstationbusTiefenbrunnen_afternoons: 23,
                    serviceIdstationbusKuesnacht_all: 26,
                    serviceIdstationbusKuesnacht_mornings: 27,
                    serviceIdstationbusKuesnacht_afternoons: 28,


                },
                choosenSelectionIds: [],
                mainservice: null,
                services: [],
                errors: [],
                selections: [],
                selectionsOrigin: [],
                dataIsInit: false,

                stationbus: null,
                schoolbus: null,
                time_stationbus: 'mornings_afternoons',
                busservices: {
                    stationbus: null,
                    schoolbus: null
                }

            }
        },
        props: {
            session: {
                type: String,
                required: true
            },
            location: {
                type: Number,
                required: true
            },
            lang: {
                type: String,
                required: true
            },
            trans: {
                type: Object,
                required: true
            },
            appmode: {
                type: String,
                required: true
            },
        },
        computed: {

            modulRelevantSelections: function () {
                let app = this;
                return this.selections.filter(function(item) {
                    let found = app.services.find(element => element.id == item.service_id);
                    return found !== undefined
                });
            },
            choosenSelections: function () {
                let app = this;
                return this.selections.filter(function(item) {
                    return app.choosenSelectionIds.indexOf(item.id) !== -1;
                });
            },
            price: function () {
                let app = this;
                return app.choosenSelections[0].service.relevantPrice.price;
            },

            priceSummary: function () {
                return this.price + this.lunchPriceTotal
            }
        },
        mounted() {
            this.loadData();
        },
        methods: {
            loadData() {

                let app = this;

                // load for each sector the services
                axios.get('/api/services/bysectors/' + this.config.sectorIds.join() + '/' + this.location)
                .then(response => {
                    this.services = this.services.concat(response.data);

                    app.dataInit();

                })
                .catch(e => {
                    this.errors.push(e)
                });
            },

            dataInit() {
                let app = this;

                app.dataIsInit = true;

            },

            schoolbusInput(){
                let app = this;
                if(app.schoolbus){
                    app.schoolbus = null;
                }else{
                    app.schoolbus = true;
                };

                app.setBusservices()
            },
            stationbusInput(station){
                let app = this;

                if(app.stationbus == station)
                {
                    app.stationbus = null
                } else {
                    app.stationbus = station;
                }

                app.setBusservices()
            },

            setBusservices(){
                let app = this;
                if(app.schoolbus)
                {
                    app.busservices.schoolbus = this.config.serviceIdSchoolbus;
                }else{
                    app.busservices.schoolbus = null;
                }

                if(app.stationbus)
                {
                    if(app.stationbus == 'Tiefenbrunnen')
                    {
                        if(app.time_stationbus == 'mornings_afternoons') app.busservices.stationbus = this.config.serviceIdstationbusTiefenbrunnen_all;
                        if(app.time_stationbus == 'mornings') app.busservices.stationbus = this.config.serviceIdstationbusTiefenbrunnen_mornings;
                        if(app.time_stationbus == 'afternoons') app.busservices.stationbus = this.config.serviceIdstationbusTiefenbrunnen_afternoons;
                    }
                    if(app.stationbus == 'Küsnacht')
                    {
                        if(app.time_stationbus == 'mornings_afternoons') app.busservices.stationbus = this.config.serviceIdstationbusKuesnacht_all;
                        if(app.time_stationbus == 'mornings') app.busservices.stationbus = this.config.serviceIdstationbusKuesnacht_mornings;
                        if(app.time_stationbus == 'afternoons') app.busservices.stationbus = this.config.serviceIdstationbusKuesnacht_afternoons;
                    }
                }else{
                    app.busservices.stationbus = null;
                }
            },

            prepairData(selections, section_id, next='pdf'){

                let app = this;
                app.selections = [];

                if(app.busservices.schoolbus)
                {
                    this.createNewSelection( app.busservices.schoolbus );
                }
                if(app.busservices.stationbus)
                {
                    this.createNewSelection( app.busservices.stationbus );
                }
                app.storeData(app.selections, section_id, next);

            },


            ...helpers,
            ...methods,




        }

    }
</script>
